/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Ready_To_PullInputs */

const en_status_ready_to_pull = /** @type {(inputs: Status_Ready_To_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to Pull`)
};

const es_status_ready_to_pull = /** @type {(inputs: Status_Ready_To_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para surtir`)
};

/**
* | output |
* | --- |
* | "Ready to Pull" |
*
* @param {Status_Ready_To_PullInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_ready_to_pull = /** @type {((inputs?: Status_Ready_To_PullInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Ready_To_PullInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_ready_to_pull(inputs)
	return es_status_ready_to_pull(inputs)
});